export const BASE_URL = process.env.REACT_APP_PROD_URL || 'https://prod-api.onmyway.com'        
